var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMCartasTrabajo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:none;}.cls-3{fill:#2eccb6;}.cls-4,.cls-7{fill:#329be6;}.cls-4{mix-blend-mode:multiply;}.cls-5{fill:#0b5c96;}.cls-6{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m_cartas_trabajo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cartas_de_Trabajo",
    "data-name": "Cartas de Trabajo"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.82 46.82 9.99 42.99 9.99 50.34 13.82 46.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "19.05 52.05 15.59 48.59 11.84 52.05 19.05 52.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "54.16 52.05 50.41 48.59 46.95 52.05 54.16 52.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "56.01 42.99 52.18 46.82 56.01 50.34 56.01 42.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M65.72,32.72,52.47,19.47v2.07l5,3.45,1.08.75V40.49l7.21-7.21A.4.4,0,0,0,65.72,32.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M7.49,25.74,8.57,25l5-3.45V19.47L.28,32.72a.4.4,0,0,0,0,.56l7.21,7.21V25.74Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "16.03 31.6 22.84 38.8 43.16 38.8 49.97 31.6 49.97 17.02 16.03 17.02 16.03 31.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M31.57,9,33,8l1.43,1,8,5.53h5.14L33.28.28a.4.4,0,0,0-.56,0L18.48,14.52h5.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32.72,65.72a.4.4,0,0,0,.56,0L44.45,54.55H21.55Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "13.53 28.96 13.53 24.59 11.03 26.32 13.53 28.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M13.53,14.92v4.55l5-4.95H13.93A.4.4,0,0,0,13.53,14.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M52.07,14.52H47.52l4.95,4.95V14.92A.4.4,0,0,0,52.07,14.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M56,50.34l-3.83-3.52-1.77,1.77,3.75,3.46H47l-2.5,2.5H58.11a.4.4,0,0,0,.4-.4V40.49L56,43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M11.84,52.05l3.75-3.46-1.77-1.77L10,50.34V43l-2.5-2.5V54.15a.4.4,0,0,0,.4.4H21.55l-2.5-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M58.51,26a.42.42,0,0,0-.17-.33L57.43,25l-5-3.45V19.47l-4.95-4.95H42.38L34.43,9l-1.2-.83a.39.39,0,0,0-.46,0L31.57,9l-7.95,5.53H18.48l-5,4.95v2.07L8.57,25l-.91.63a.42.42,0,0,0-.17.33V40.49L10,43V28.86L20.85,40.33l-7,6.49,1.77,1.77,7.9-7.29h19l7.9,7.29,1.77-1.77-7-6.49L56,28.86V43l2.5-2.5V26Zm-45,3L11,26.32l2.5-1.73ZM33,11.05l5,3.47H28ZM50,31.6l-6.81,7.2H22.84L16,31.6V17H50ZM52.47,29V24.59L55,26.32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "19.05 52.05 21.55 54.55 44.45 54.55 46.95 52.05 19.05 52.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M16,17V31.6l6.81,7.2H43.16L50,31.6V17ZM45.47,33.6a.4.4,0,0,1-.4.4H20.93a.4.4,0,0,1-.4-.4V26.45a.4.4,0,0,1,.4-.4H45.07a.4.4,0,0,1,.4.4Zm0-9.92a.4.4,0,0,1-.4.4H20.93a.4.4,0,0,1-.4-.4V20.4a.4.4,0,0,1,.4-.4H45.07a.4.4,0,0,1,.4.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 20.53,
    y: 20,
    width: 24.94,
    height: 4.08,
    rx: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 20.53,
    y: 26.05,
    width: 24.94,
    height: 7.95,
    rx: 0.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "38 14.52 33 11.04 28 14.52 38 14.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "56.01 50.34 56.01 28.86 45.15 40.33 56.01 50.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "54.97 26.32 52.47 24.59 52.47 28.96 54.97 26.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "20.85 40.33 9.99 28.86 9.99 50.34 20.85 40.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "23.49 41.3 11.84 52.05 54.16 52.05 42.51 41.3 23.49 41.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "13.53 28.96 13.53 24.59 11.93 25.7 11.03 26.32 13.53 28.96"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 66,
    height: 66
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMCartasTrabajo);
export default __webpack_public_path__ + "static/media/m_cartas_trabajo.7bb385100df6157bbcf1605fe961db7f.svg";
export { ForwardRef as ReactComponent };